import React, { ChangeEvent } from 'react'
import { Button } from '@/components/ui/button'
import { Heading3 } from '@/components/ui/typography'
import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { FormBaseRow, FormRowReversed } from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormSubmitValues } from 'utils/formValidation'

import {
  FormErrorMessage,
  FormFieldBlock,
  FormFieldGroup,
  FormFieldLabel,
  MultiAdjustmentTemplate,
} from '../Transactions.styles'

export interface TransactionIBCommissionReverseFormValues {
  comment: string
}

const TransactionReverseIBCommissionFormUI: React.FC<
  FormikProps<TransactionIBCommissionReverseFormValues> & OuterProps
> = (props) => {
  const { handleSubmit, errors, isSubmitting, setSubmitting } = props

  const handleSubmitForm = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault()
    setSubmitting(true)
    handleSubmit()
  }

  return (
    <MultiAdjustmentTemplate>
      <Form onSubmit={handleSubmitForm}>
        <Heading3>
          Reverse Transaction <span className='blue'>({props.transaction.referenceId})</span>
        </Heading3>
        <FormFieldBlock>
          <FormBaseRow>
            <FormFieldLabel>Comment</FormFieldLabel>
            <FormFieldGroup>
              <Field
                component='textarea'
                name='comment'
                placeholder='Enter comment'
                rows='3'
                maxLength='130'
              />
            </FormFieldGroup>
          </FormBaseRow>
          {errors.comment && <FormErrorMessage>{errors.comment}</FormErrorMessage>}
        </FormFieldBlock>
        <FormFieldBlock>
          <FormBaseRow>
            <FormRowReversed>
              <Button type='submit' disabled={isSubmitting}>
                Submit
              </Button>
            </FormRowReversed>
          </FormBaseRow>
        </FormFieldBlock>
      </Form>
    </MultiAdjustmentTemplate>
  )
}

interface OuterProps {
  transaction: TransactionDto

  onSubmit(values: FormSubmitValues<TransactionIBCommissionReverseFormValues>): Promise<void>
}

export const TransactionReverseIBCommissionForm = withFormik<
  OuterProps,
  TransactionIBCommissionReverseFormValues
>({
  mapPropsToValues: () => {
    return {
      comment: '',
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    await props.onSubmit(values)
    setSubmitting(false)
  },
  validate: (values) => {
    const errors: FormikErrors<TransactionIBCommissionReverseFormValues> = {}
    if (!values.comment) {
      errors.comment = 'required'
    }
    return errors
  },
  isInitialValid: false,
  enableReinitialize: true,
})(TransactionReverseIBCommissionFormUI)
